module.exports = __webpack_public_path__ + "img/banner_guanyuwome.5e229dcb.png";